module.exports = __webpack_public_path__ + "static/media/lock-tool-white.6202eb73.svg";